import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionMonitorPage } from '@/modules/monitor/pages/SubscriptionMonitorPage';

export const Route = createFileRoute('/dashboard/monitor/')({
  component: SubscriptionMonitorPage,
});
